import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from './auth.service';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private cartId: string | null = null;
  cartIdSubject: Subject<string | null> = new Subject();
  constructor(private readonly authService: AuthService, private readonly cookieService: CookieService) {}

  isUserLoggedIn(): boolean {
    return !!this.authService.currentUserValue;
  }

  setCartId(cartId: string) {
    if (this.authService.currentUserValue) {
      this.cartId = cartId;
    } else {
      this.cookieService.set('cartId', cartId, 7 * 24 * 3600, '/');
    }
    this.cartIdSubject.next(cartId);
  }

  getCartId() {
    if (this.authService.currentUserValue) {
      return this.cartId;
    }
    return this.cookieService.get('cartId');
  }

  removeCart() {
    if (this.authService.currentUserValue) {
      this.cartId = null;
    } else {
      this.cookieService.delete('cartId', '/');
    }
    this.cartIdSubject.next(null);
  }
}
